import { optionSchema } from '@/common/schemas/option.schema'
import { unFormatCurrency, unFormatPercentage } from '@/common/utils/unFormatters'
import { z } from 'zod'

export const createSpecialEntrySchema = z
  .object({
    target_id: optionSchema,
    fee_template_id: optionSchema,
    calculate_as: z.string(),
    value: z.string({ message: 'Campo obrigatório' }),
  })
  .superRefine((data, ctx) => {
    const unFormatFunction = data.calculate_as === 'percentage' ? unFormatPercentage : unFormatCurrency

    if(unFormatFunction(data.value) === 0) {
      ctx.addIssue({
        path: ['value'],
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
      })
    }

    if (!unFormatFunction(data.value)) {
      ctx.addIssue({
        path: ['current_equipment_usage'],
        code: z.ZodIssueCode.custom,
        message: 'Campo obrigatório',
      })
    }
  })

export type CreateSpecialEntryValidationSchema = z.infer<typeof createSpecialEntrySchema>
